export default function AuthPrimaryButton({
  type = 'button',
  disabled = false,
  className = '',
  children,
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`w-full h-11 md:h-12 rounded-full bg-[#119975] text-[#FFEBDB] font-poppins text-base md:text-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-opacity ${className}`}
    >
      {children}
    </button>
  );
}

